const ABApplicationCore = require("../core/ABApplicationCore");
module.exports = class ABApplication extends ABApplicationCore {};
